export const LOGGER_LOG = "LOGGER_LOG";
export const LOGGER_ERROR = "LOGGER_ERROR";
export const LOGGER_LOGS_SEND_PENDING = "LOGGER_LOGS_SEND_PENDING";
export const LOGGER_LOGS_SEND_FULFILLED = "LOGGER_LOGS_SEND_FULFILLED";
export const LOGGER_LOGS_SEND_REJECTED = "LOGGER_LOGS_SEND_REJECTED";

// logger events should not contain spaces
export const EVENT_ERROR_OCCURED = "ERROR_OCCURED"; // Event for errors (null, message)
export const EVENT_FAILED_PROMISE = "FAILED_PROMISE"; // null, reason
export const EVENT_PERFORM_ACTION_PENDING = "PERFORM_ACTION_PENDING"; // 1, url
export const EVENT_PERFORM_ACTION_SUCCEEDED = "PERFORM_ACTION_SUCCEEDED"; // 1, url
export const EVENT_PERFORM_ACTION_FAILED = "PERFORM_ACTION_FAILED"; // 1, url, reason
export const EVENT_BATCH_PUSHED = "BATCH_PUSHED"; // batch_number, total files message
export const EVENT_FILE_UPLOAD_STARTED = "FILE_UPLOAD_STARTED"; // 1, file path
export const EVENT_FROM_BACKOFFICE_STORAGE_PROXY =
  "EVENT_FROM_BACKOFFICE_STORAGE_PROXY"; // 1, message created by BSP
export const EVENT_FROM_BACKOFFICE_PHOTO_VALIDATION =
  "EVENT_FROM_BACKOFFICE_PHOTO_VALIDATION"; // 1, ''
export const EVENT_PILOT_APP_LINK_OPENED = "EVENT_PILOT_APP_LINK_OPENED";

export const EVENT_UPLOAD_CANCELED = "UPLOAD_CANCELED"; // 1, ''
export const EVENT_UPLOAD_RESET = "UPLOAD_RESET"; // 1, ''
export const EVENT_UPLOAD_CONFIRMED = "UPLOAD_CONFIRMED"; // 1, ''
export const EVENT_UPLOAD_CONTROLS_ARE_SHOWN = "UPLOAD_CONTROLS_ARE_SHOWN"; // 1, ''
export const EVENT_TAB_CLOSE = "TAB_CLOSE"; // 1, ''
export const EVENT_APP_STARTED = "APP_STARTED"; // 1, ''
export const EVENT_ROUTE_CHANGED = "ROUTE_CHANGED"; // 1, newRoute
export const EVENT_ACCESS_TOKEN_UPDATED = "ACCESS_TOKEN_UPDATED";
export const EVENT_HTTP_REQUEST_SENT = "HTTP_REQUEST_SENT";
export const EVENT_HTTP_REQUEST_SUCCEEDED = "HTTP_REQUEST_SUCCEEDED";
export const EVENT_HTTP_REQUEST_FAILED = "HTTP_REQUEST_FAILED";
